import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteMultiRandomControlProps } from './DeleteMultiRandomControl.types';

export const DeleteMultiRandomControl = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteMultiRandomControlProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.KONTROLA]?.edit;

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<TrashIcon />}
          onClick={onModalOpen}
          disabled={isPermsDisabled}
        >
          {formatMessage({ id: AppMessages['control.random.multiAction.delete.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        size="medium"
        header={formatMessage({ id: AppMessages['control.random.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['control.random.multiAction.delete.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['control.random.multiAction.delete.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>
          {formatMessage({ id: AppMessages['control.random.multiAction.delete.text'] })}
        </ActionModal.Text>
      </ActionModal>
    </>
  );
};
